module.exports = __webpack_public_path__ + "img/logo-success4.2eb01ca9.jpg";